import { useRoutes } from 'react-router-dom';

// routes
import MainRoutes from './MainRoutes';
import LoginRoutes from './LoginRoutes';
//import AuthenticationRoutes from './AuthenticationRoutes';

// ==============================|| ROUTING RENDER ||============================== //

/*
export default function ThemeRoutes() {
  return useRoutes([MainRoutes, AuthenticationRoutes]);
  //return useRoutes([LoginRoutes, AuthenticationRoutes, MainRoutes]);
}
*/

export default function ThemeRoutes({ isAuthenticated }) {
  const routesToUse = isAuthenticated ? [MainRoutes] : [LoginRoutes];
  return useRoutes(routesToUse);
  //console.log('isAuthenticated', isAuthenticated);
  //return useRoutes([MainRoutes]);
}
